import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ExploreService } from '../../../../shared/services/explore.service';
@Component({
    selector: 'app-explore',
    templateUrl: './explore.component.html',
    styleUrls: ['./explore.component.scss'],
})
export class ExploreComponent implements OnInit {
    news: any;
    main: {};
    learn: [];
    error: boolean = false;
    errMsg: string;

    constructor(
        private SpinnerService: NgxSpinnerService,
        private api: ExploreService
    ) {}

    ngOnInit() {
        this.fetchNews();
        this.fetchLearn();
    }

    fetchNews() {
        this.SpinnerService.show();
        this.api.news().subscribe(
            (res: any) => {
                this.main = res.data[0];
                this.news = [...res.data].splice(1);
                this.SpinnerService.hide();
            },
            (err) => {
                this.SpinnerService.hide();
                this.error = true;
                this.errMsg = err.error.message
            }
        );
    }

    fetchLearn() {
        this.api.learn().subscribe((res: any) => {
            if(res){
                this.learn = res.data;
                console.log(this.learn,'mmmmm')
            }
            else
            console.log(res);
            
        },
        (err) => {
            this.SpinnerService.hide();
            this.error = true;
            this.errMsg = err.error.message;
        }
        );
    }
}
